export default __webpack_public_path__ + "static/Old-Grand-Palace-d342e0663e87016c0dbfa7a7d0afd581.jpg";